// import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import "./section-videos-content.scss"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import useMediaQuery from "../../../shared/utils/useMediaQuery"

const SectionVideosContent = ({ videos }) => {
  

  const isMobile = useMediaQuery()

  
  const videoCardDatalayer = (article) => {
    const userInfoEncrypt = encryptUserInfo()

    pushDataLayerEvent({
      event: "Interacciones - Videos",
      category: "Magazin",
      sub_category: "Nuestro mundo",
      action: "click",
      label: `/magazin/nuestro-mundo/${article.slug}`,
      video_name: article.tituloArticulo,
      location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const listItems = videos.map((info, index) => {
    return (
      <a
        className={"f-carousel-videos-item f-carousel-videos-pos-" + index}
        key={index}
        href={info.enlaceVideo}
        target="_blank"
        onClick={(e) => {
          videoCardDatalayer(info)
        }}
      >
        {isMobile ? (
          <img
            className="f-carousel-videos-imagen"
            loading="lazy"
            alt={info.imagenDelPaso.description}
            src={info.imagenDelPaso.file.url}
          />
        ) : (
          <img
            className="f-carousel-videos-imagen"
            alt={info.imagenDelPaso.description}
            src={info.imagenDelPaso.file.url}
          />
        )}
        <div className="f-carousel-videos-description">
          <span className="icon-play" />
          <p>{info.title}</p>
        </div>
      </a>
    )
  })

  const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-videos-next" onClick={onClick} />
  }
  
  var settings = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: <NextArrow />,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: false,
          initialSlide: 0,
          centerPadding: "30px",
          slidesToShow: 1,
          centerMode: true,
        },
      },
    ],
  }
  return (
    <div className="f-SectionVideosContent">
      <div className="f-SectionVideosContent-title">
        <h2>Nosotras Videos</h2>
      </div>
      <Slider {...settings} className="f-carousel-videos">
        {listItems}
      </Slider>
    </div>
  )
}

export default SectionVideosContent
